import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Image } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import SunshineTag from 'components/_core/SunshineTag';

export type CardType = {
  id: string;
  disabled: boolean;
  title: string;
  to: string;
  image: {
    src: string;
    opacity?: number;
  };
  description: string;
  label: string;
  infoTag: {
    type: 'INSTANT' | 'TIMER';
    text: string;
  };
};

type Props = {
  card: CardType;
};

const Card: FC<Props> = ({ card }) => {
  return (
    <SunshineCard
      alignItems="start"
      as={RouterLink}
      isDisabled={card.disabled}
      title={card.title}
      to={card.to}
    >
      <SunshineCard.Slot name="aside">
        <Image
          alt={card.title}
          opacity={card.image.opacity}
          role="presentation"
          src={card.image.src}
          width={110}
        />
      </SunshineCard.Slot>

      <SunshineCard.Content>
        <SunshineCard.Text>{card.description}</SunshineCard.Text>
        <SunshineCard.Text
          fontWeight="weight-500"
          paddingTop="space-12"
          variant="primary"
        >
          {card.label}
        </SunshineCard.Text>
      </SunshineCard.Content>

      <SunshineCard.Slot name="action">
        {card.infoTag.type === 'INSTANT' ? (
          <SunshineTag colorScheme="orange" icon="flash" size="sm">
            {card.infoTag.text}
          </SunshineTag>
        ) : (
          <SunshineCard.Text>
            <SunshineIcon name="timer" /> {card.infoTag.text}
          </SunshineCard.Text>
        )}

        <SunshineIcon color="grey.600" name="chevron-right" size="icon-20" />
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default Card;
